import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
const TermsOfServicePage = () => {
  return <div className="min-h-screen bg-black text-white" data-id="element-496">
      <div className="container mx-auto px-4 py-16 max-w-4xl" data-id="element-497">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} data-id="element-498">
          <div className="flex justify-center mb-10" data-id="element-499">
            <Link to="/" data-id="element-500">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/8FoTH3xeKncC1VAra4Rj1n/partners516.png" alt="516 Partners Logo" className="h-12 w-auto" data-id="element-501" />
            </Link>
          </div>
          <h1 className="typekit-heading text-3xl md:text-4xl text-center text-white mb-10" data-id="element-502">
            Terms of Service
          </h1>
          <div className="text-gray-300 libre-caslon-text-regular space-y-8" data-id="element-503">
            <div className="mb-6" data-id="element-504">
              <p className="text-gray-400" data-id="element-505">
                <strong data-id="element-506">Effective Date:</strong> October 21, 2025
                <br data-id="element-507" />
                <strong data-id="element-508">Company Name:</strong> 516 Partners
                <br data-id="element-509" />
                <strong data-id="element-510">Website:</strong> https://516partners.com
              </p>
            </div>
            <div className="mb-6" data-id="element-511">
              <h2 className="text-xl text-[#ffdf07] mb-3 typekit-heading" data-id="element-512">
                1. Acceptance of Terms
              </h2>
              <p className="leading-relaxed" data-id="element-513">
                By accessing or using the 516 Partners website or services, you
                agree to these Terms of Service. If you do not agree, please
                discontinue use immediately.
              </p>
            </div>
            <div className="mb-6" data-id="element-514">
              <h2 className="text-xl text-[#ffdf07] mb-3 typekit-heading" data-id="element-515">
                2. Services Provided
              </h2>
              <p className="leading-relaxed" data-id="element-516">
                516 Partners offers consulting and educational services for
                business owners, including the Exit Readiness Assessment and
                related business improvement programs. Our services are designed
                to provide insights, guidance, and clarity — not financial,
                legal, or investment advice.
              </p>
            </div>
            <div className="mb-6" data-id="element-517">
              <h2 className="text-xl text-[#ffdf07] mb-3 typekit-heading" data-id="element-518">
                3. Eligibility
              </h2>
              <p className="leading-relaxed" data-id="element-519">
                You must be at least 18 years old and authorized to act on
                behalf of a business entity to participate in our programs or
                assessments.
              </p>
            </div>
            <div className="mb-6" data-id="element-520">
              <h2 className="text-xl text-[#ffdf07] mb-3 typekit-heading" data-id="element-521">
                4. No Guarantees
              </h2>
              <p className="leading-relaxed" data-id="element-522">
                516 Partners does not guarantee specific financial results,
                valuation increases, or successful sale outcomes. The
                information provided is for educational and strategic purposes
                only.
              </p>
            </div>
            <div className="mb-6" data-id="element-523">
              <h2 className="text-xl text-[#ffdf07] mb-3 typekit-heading" data-id="element-524">
                5. Intellectual Property
              </h2>
              <p className="leading-relaxed" data-id="element-525">
                All materials, reports, videos, designs, and other content
                produced by 516 Partners remain the property of the company. You
                may not copy, reproduce, or distribute any material without
                prior written consent.
              </p>
            </div>
            <div className="mb-6" data-id="element-526">
              <h2 className="text-xl text-[#ffdf07] mb-3 typekit-heading" data-id="element-527">
                6. Limitation of Liability
              </h2>
              <p className="leading-relaxed" data-id="element-528">
                516 Partners is not liable for any direct, indirect, or
                incidental damages resulting from your use of our services,
                including lost profits or opportunities. All information is
                provided "as is" without warranties of any kind.
              </p>
            </div>
            <div className="mb-6" data-id="element-529">
              <h2 className="text-xl text-[#ffdf07] mb-3 typekit-heading" data-id="element-530">
                7. Payment Terms
              </h2>
              <p className="leading-relaxed" data-id="element-531">
                If any paid services are offered, terms and pricing will be
                clearly displayed prior to purchase. All payments are final
                unless otherwise stated in writing.
              </p>
            </div>
            <div className="mb-6" data-id="element-532">
              <h2 className="text-xl text-[#ffdf07] mb-3 typekit-heading" data-id="element-533">
                8. Third-Party Links
              </h2>
              <p className="leading-relaxed" data-id="element-534">
                Our site or communications may contain links to third-party
                websites. 516 Partners is not responsible for their content,
                accuracy, or privacy practices.
              </p>
            </div>
            <div className="mb-6" data-id="element-535">
              <h2 className="text-xl text-[#ffdf07] mb-3 typekit-heading" data-id="element-536">
                9. Governing Law
              </h2>
              <p className="leading-relaxed" data-id="element-537">
                These Terms are governed by the laws of the State of Texas,
                without regard to its conflict of law principles.
              </p>
            </div>
            <div className="mb-6" data-id="element-538">
              <h2 className="text-xl text-[#ffdf07] mb-3 typekit-heading" data-id="element-539">
                10. Contact
              </h2>
              <p className="leading-relaxed" data-id="element-540">
                For questions regarding these Terms or our Privacy Policy,
                contact us at:
                <br data-id="element-541" />
                📧 info@516partners.com
                <br data-id="element-542" />
                🌐 https://516partners.com
              </p>
            </div>
          </div>
          <div className="mt-12 text-center" data-id="element-543">
            <Link to="/" className="text-[#ffdf07] hover:underline" data-id="element-544">
              Return to Home
            </Link>
          </div>
        </motion.div>
      </div>
      <footer className="border-t border-gray-800 py-8 px-4 mt-16" data-id="element-545">
        <div className="max-w-4xl mx-auto text-center" data-id="element-546">
          <p className="text-gray-400 text-sm mb-4" data-id="element-547">
            © 2025 516 Partners LLC. All rights reserved.
          </p>
          <div className="flex justify-center space-x-4" data-id="element-548">
            <Link to="/privacypage" className="text-gray-500 hover:text-[#ffdf07] text-xs transition-colors" data-id="element-549">
              Privacy Policy
            </Link>
            <span className="text-gray-600" data-id="element-550">|</span>
            <Link to="/termsofservice" className="text-gray-500 hover:text-[#ffdf07] text-xs transition-colors" data-id="element-551">
              Terms of Service
            </Link>
          </div>
        </div>
      </footer>
    </div>;
};
export default TermsOfServicePage;